/** Fecha y hora completas, siempre con `Intl` (CLAUDE.md §6). Para la papelera y el perfil. */
export function formatDateTime(isoDateTime: string, locale: string): string {
  return new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeStyle: 'short' }).format(
    new Date(isoDateTime),
  )
}

/** Cada unidad y cuántas de ella caben en la siguiente. */
const RELATIVE_STEPS: readonly [Intl.RelativeTimeFormatUnit, number][] = [
  ['second', 60],
  ['minute', 60],
  ['hour', 24],
  ['day', 7],
  ['week', 4.35],
  ['month', 12],
  ['year', Number.POSITIVE_INFINITY],
]

/** "hace 5 min", "ayer"… con `Intl.RelativeTimeFormat`. Para la actividad reciente del Inicio (fase 7). */
export function formatRelativeTime(isoDateTime: string, locale: string, now: number = Date.now()): string {
  const formatter = new Intl.RelativeTimeFormat(locale, { numeric: 'auto', style: 'short' })
  let value = (new Date(isoDateTime).getTime() - now) / 1000
  for (const [unit, size] of RELATIVE_STEPS) {
    if (Math.abs(value) < size) return formatter.format(Math.round(value), unit)
    value /= size
  }
  return formatDateTime(isoDateTime, locale)
}
